import { ModuleWithProviders, NgModule } from '@angular/core';
import { StaffFileService } from './file.service';

@NgModule({})
export class StaffFileModule {
  static forRoot(): ModuleWithProviders<StaffFileModule> {
    return {
      ngModule: StaffFileModule,
      providers: [StaffFileService],
    };
  }
}
